import React from 'react';
import { Handle, Position } from 'reactflow';
import TopHeaderPanel from '../TopHeaderPanel';
import Top_input from '../Top_input';
import Bottom_input from '../Bottom_input';


const ChatOutputNode = ({ id, data }) => {
  const label = data?.label || 'Chat Output';
 
  return (
    <div className='node-style'>
      <div className='thpw'>{data.selectedNodeId === id && <TopHeaderPanel />}</div>
      
    <div className="node">
      <div className='node_head'>
      <span><i className='ri-question-answer-line'></i></span>
        {label} <i className="mdi mdi-close" onClick={(e) => {
            e.stopPropagation();
            if (data?.onDelete) {
              data.onDelete(id);
            }
          }}></i>
          <p>Display a chat message in the Playground.</p>
          </div>
          
          <div className='node_body'>
            <Top_input />
              <div>
                <label>Text</label>
                {/* <input defaultValue={data?.text || ''} placeholder="Receiving input" disabled/> */}
                <textarea
                        defaultValue={data?.text || ''}
                        placeholder="Receiving input" 
                        disabled
                        rows={3} 
                        style={{ width: '100%' }} 
                        className="nodrag f-10 border" 
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        onDoubleClick={(e) => e.stopPropagation()}
                      />
              </div>
              <Bottom_input />
            </div>
            <Handle type="source" position={Position.Right} />
          <Handle type="target" position={Position.Left} />
    </div>
    </div>
    
  );
};

export default ChatOutputNode;
